import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PHONE_CONFIRMATION_TYPE } from '@shared/pages/phone-confirmation/phone-confirmation-type';
import { LocationCheckGuard } from '@shared/guards/location-check.guard';

export const LcoRoutesMap = {
  base: 'lco',
  phoneConfirmation: 'phone-confirmation',
  getStarted: 'get-started',
  partySize: 'party-size',
  guestsData: 'guests-data',
  tacitFlow: 'tacit-flow',
  rateThisSong: 'rate-this-song'
}

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
  },
  {
    path: LcoRoutesMap.phoneConfirmation,
    data: {
      animation: LcoRoutesMap.phoneConfirmation,
      type: PHONE_CONFIRMATION_TYPE.LCO
    },
    canActivate: [LocationCheckGuard],
    loadChildren: () => import('@shared/pages/phone-confirmation/phone-confirmation.module').then(m => m.PhoneConfirmationModule),
  },
  {
    path: LcoRoutesMap.getStarted,
    data: {
      animation: LcoRoutesMap.getStarted,
    },
    canActivate: [LocationCheckGuard],
    loadChildren: () => import('./pages/lco-get-started/lco-get-started.module').then(m => m.LcoGetStartedModule)
  },
  {
    path: LcoRoutesMap.partySize,
    data: {
      animation: LcoRoutesMap.partySize,
    },
    canActivate: [LocationCheckGuard],
    loadChildren: () => import('./pages/party-size/party-size.module').then(m => m.PartySizeModule)
  },
  {
    path: LcoRoutesMap.guestsData,
    data: {
      animation: LcoRoutesMap.guestsData,
    },
    canActivate: [LocationCheckGuard],
    loadChildren: () => import('./pages/guests-data/guests-data.module').then(m => m.GuestsDataModule)
  },
  {
    path: LcoRoutesMap.tacitFlow,
    data: {
      animation: LcoRoutesMap.tacitFlow,
    },
    canActivate: [LocationCheckGuard],
    loadChildren: () => import('./pages/tacit-flow/tacit-flow.module').then(m => m.TacitFlowModule)
  },
  {
    path: LcoRoutesMap.rateThisSong,
    data: {
      animation: LcoRoutesMap.rateThisSong,
    },
    loadChildren: () => import('./pages/rx-music-rate/rx-music-rate.module').then(m => m.RxMusicRateModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LcoRoutingModule { }
